// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2024-09-23 22:19:25 +0200 (Mon, 23 Sep 2024) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 146131 $
//  Purpose   : parts for presenation nodes
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {loadLazy} from 'uix/parts'

// ---Local imports

// ---Globals
export const PresentationEditor = loadLazy(() =>
  import(/* webpackChunkName: 'presentation' */ './editor')
)

export const PresentationViewer = loadLazy(() =>
  import(/* webpackChunkName: 'presentation' */ './viewer')
)
